export default __webpack_public_path__ + "c7444bbb3d4421f0bda652905a9a5c0c.png";